import { Dialog, DialogContent } from '@/components/Dialog/Dialog';
import { RepoForm, useRepoState } from '@/components/Hub/RepoForm';
import { useUpdateRepoMutation } from '@/hooks/useSwr';
import { RepoWithLookupsSchema } from '@/types/schema';

function EditPromptMetadataContent(props: {
  repo: RepoWithLookupsSchema;
  onClose: () => void;
}) {
  const [repoState, setRepoState] = useRepoState({
    owner: props.repo.owner,
    repo_handle: props.repo.repo_handle,
    description: props.repo.description ?? '',
    readme: props.repo.readme ?? '',
    is_public: props.repo.is_public,
    tags: props.repo.tags,
    is_archived: props.repo.is_archived,
  });

  const { trigger: updateRepo, error: updateError } = useUpdateRepoMutation(
    props.repo.owner,
    props.repo.repo_handle
  );

  const onSubmit = async () => {
    const res = await updateRepo({
      json: {
        description: repoState.description,
        readme: repoState.readme,
        is_public: repoState.is_public,
        tags: repoState.tags,
        is_archived: repoState.is_archived,
      },
    });
    if (res !== undefined) {
      props.onClose();
    }
  };

  return (
    <RepoForm
      repo={repoState}
      setRepo={setRepoState}
      tenantHandle={props.repo.owner}
      onSubmit={onSubmit}
      error={updateError}
      mode="edit"
      hideTitle
    />
  );
}

export function EditPromptMetadataDialog(props: {
  open: boolean;
  onClose: () => void;
  repo: RepoWithLookupsSchema;
}) {
  const { open, onClose, repo } = props;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        title="Edit Prompt Metadata"
        className="max-h-[80vh] overflow-y-auto"
      >
        <EditPromptMetadataContent repo={repo} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
